<template>
  <button
    v-bind="$attrs"
    :class="[
      'text-gray-80 bg-gray-20 flex h-6 w-max items-center gap-2 rounded px-2 text-xs font-medium duration-200 ease-out',
      'hover:bg-gray-30 focus:bg-active-secondary aria-expanded:bg-active-secondary [&>svg]:text-gray-60 [&>svg]:icon-s [&>svg]:duration-200 [&>svg]:ease-out',
    ]"
    type="button"
  >
    <slot name="icon" />
    {{ title }}
  </button>
</template>

<script lang="ts" setup>
// This component is deprecated and will be removed in the future
// Please use UiMenuFilterTrigger instead
defineProps<{
  title?: string
}>()
</script>
